import { Tooltip, OverlayTrigger } from "react-bootstrap";

const CustomToolTip = (props) => {
    const { placement="top", delay, overlayText, children, ...rest } = props
    return <OverlayTrigger placement={placement} delay={delay} overlay={<Tooltip {...rest}>{overlayText}</Tooltip>}>
        {children}
    </OverlayTrigger>

}
export default CustomToolTip;
